<template>
  <div id="myCarousel" class="carousel slide" data-ride="carousel">
   <!--  <ol class="carousel-indicators">
      <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
    </ol> -->
    <div class="carousel-inner">
      
      <div class="carousel-item active">
        <img class="w-100" src="@/assets/img/carousel/1.jpg" alt="First slide">
        <div class="container">
          <div class="carousel-caption text-left">
            <h1>Почему мы можем быть Вам полезны:</h1>
            <ul style="font-size:1.1em;">
              <li>У Вас всё еще нет СХД NetApp.</li>
              <li>У Вас есть СХД NetApp, но нет DevOps.</li>
              <li>Вас интересуют возможности использования свободного ПО.</li>
              <li>Вас интересует весь комплекс вопросов связанных с ИТ.</li>
              <li>ALL YOU NEED IS LAB :)</li>
            </ul>
          </div>
        </div>
      </div>
      
    </div>
   <!--  <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a> -->
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style scoped>
  @media (max-width: 575.98px) {
  .carousel-item img {
    min-height: 550px;
    object-fit: cover;
  }
  h1 {
    font-size: 2em;
  }
  .customers .card {
    border: 1px solid rgba(0,0,0,0);
  }
  .customers .card:hover {
    border: 1px solid rgba(0,0,0,.125);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/Carousel.vue